import React from 'react'
import { Icon } from '../../atoms/Icon'
import { IconButton } from '../../atoms/IconButton'
import { IconName } from '../../atoms/Icon/Icon.types'
import { ContactCardProps } from './ContactCard.types'
import {
  StyledContactCard,
  ContactHeader,
  ContactTitle,
  MandateBadge,
  ContactsList,
  ContactItem,
  ContactAvatar,
  ContactInfo,
  ContactName,
  ContactRole,
  ContactActions,
} from './ContactCard.styles'

export const ContactCard: React.FC<ContactCardProps> = ({
  title,
  contacts,
  mandateType,
  mandateIcon = 'tag',
  showContactButtons = false,
  onContactClick,
  className,
}) => {
  const getContactIcon = (type?: string): IconName => {
    switch (type) {
      case 'individual':
        return 'user'
      case 'company':
        return 'building'
      case 'professional':
      default:
        return 'briefcase'
    }
  }

  const getContactRole = (type?: string) => {
    switch (type) {
      case 'individual':
        return 'Individual'
      case 'company':
        return 'Company'
      case 'professional':
      default:
        return 'Professional'
    }
  }

  return (
    <StyledContactCard className={className}>
      <ContactHeader>
        <ContactTitle>{title}</ContactTitle>
        {mandateType && (
          <MandateBadge $type={mandateType.toLowerCase()}>
            <Icon name={mandateIcon} size="xs" />
            {mandateType} Mandate
          </MandateBadge>
        )}
      </ContactHeader>

      <ContactsList>
        {contacts.map((contact, index) => (
          <ContactItem
            key={index}
            $clickable={!!onContactClick}
            onClick={() => onContactClick?.(contact)}
          >
            <ContactAvatar>
              {contact.avatar ? (
                <img src={contact.avatar} alt={contact.name} />
              ) : (
                <Icon name={getContactIcon(contact.type)} size="small" />
              )}
            </ContactAvatar>
            <ContactInfo>
              <ContactName>{contact.name}</ContactName>
              {contact.showRole !== false && (
                <ContactRole>
                  {contact.role || getContactRole(contact.type)}
                </ContactRole>
              )}
            </ContactInfo>
            {showContactButtons && (contact.phone || contact.email) && (
              <ContactActions>
                {contact.phone && (
                  <IconButton
                    variant="ghost"
                    size="small"
                    aria-label="Call contact"
                  >
                    <Icon name="phone" size="small" />
                  </IconButton>
                )}
                {contact.email && (
                  <IconButton
                    variant="ghost"
                    size="small"
                    aria-label="Email contact"
                  >
                    <Icon name="mail" size="small" />
                  </IconButton>
                )}
              </ContactActions>
            )}
            {onContactClick && !showContactButtons && (
              <Icon name="external-link" size="small" />
            )}
          </ContactItem>
        ))}
      </ContactsList>
    </StyledContactCard>
  )
}
